import { DateTime } from 'luxon'

export const ARTICLE_TIMEZONE = 'America/Sao_Paulo'

export const ARTICLE_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm'

export const ALLOW_FUTURE_PUBLISHED_AT = true

export const publishedAtToFormValue = (value) => {
  if (!value) return null

  const parsed = DateTime.fromISO(value, { zone: ARTICLE_TIMEZONE })

  return parsed.isValid ? parsed.toFormat(ARTICLE_DATETIME_FORMAT) : null
}

export const isNonExistentPublishedAt = (value) => {
  if (!value) return false

  const parsed = DateTime.fromFormat(String(value), ARTICLE_DATETIME_FORMAT, { zone: ARTICLE_TIMEZONE })

  return parsed.isValid && parsed.toFormat(ARTICLE_DATETIME_FORMAT) !== String(value)
}

export const parseFormValue = (value) => {
  if (!value) return null

  const parsed = DateTime.fromFormat(String(value), ARTICLE_DATETIME_FORMAT, { zone: ARTICLE_TIMEZONE })

  if (!parsed.isValid || parsed.toFormat(ARTICLE_DATETIME_FORMAT) !== String(value)) return null

  return parsed
}

export const isFuturePublishedAt = (value) => {
  const parsed = parseFormValue(value)

  return parsed !== null && parsed > DateTime.now().setZone(ARTICLE_TIMEZONE)
}

export const maxPublishedAt = () => {
  return ALLOW_FUTURE_PUBLISHED_AT
    ? null
    : DateTime.now().setZone(ARTICLE_TIMEZONE).toFormat(ARTICLE_DATETIME_FORMAT)
}
